import { render, staticRenderFns } from "./MyRecommendations.vue?vue&type=template&id=30406e7c&scoped=true"
import script from "./MyRecommendations.vue?vue&type=script&lang=ts"
export * from "./MyRecommendations.vue?vue&type=script&lang=ts"
import style0 from "./MyRecommendations.vue?vue&type=style&index=0&id=30406e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30406e7c",
  null
  
)

export default component.exports